import vrb from 'bsm-validation-rules';
import { types } from '@/helpers/validations';

export const rules = {
  masterParameterID: [vrb.presence(), vrb.typeOf('integer')],
  value: [vrb.presence(), ...types.parameterValue],
  status: [vrb.presence(), vrb.typeOf('string')],
};
